import React, { Fragment } from "react";
import styled from "styled-components";

import { Box, Heading as GHeading, Markdown, Paragraph } from "grommet";

export const StyledHeading = styled(GHeading)`
  font-weight: 50;
`;

const Heading = ({ size, ...rest }: { size: string }) => (
  <Fragment>
    <Box direction="row" {...rest}>
      <StyledHeading size={size}>Angula</StyledHeading>
      <GHeading size={size}>Rank</GHeading>
    </Box>
    <Paragraph margin={{ top: "none" }} textAlign="center" size="large">
      <Markdown>
        **ranks** the [Github Angular Organization](https://github.com/angular) **contributors** in an **unified way** 🎉
      </Markdown>
    </Paragraph>
  </Fragment>
);


export { Heading };
